
$(window).scroll(function() {
  if($(window).scrollTop() == $(document).height() - $(window).height()) {
    $('#loading-img').addClass("active");
    setTimeout(function () {
      $('#loading-img').removeClass("active");
      $('#more-indicator').trigger('click');

    }, 1000);
  }
});

$(document).ready(function(){


  var count = 5;
  var countImage = $("#images-look .image-item").length;

  $("#images-look .image-item").each(function(index, item) {
    if( index < 5 ){
      $(item).removeClass("hidden");
    }
  });
  $("#more-indicator").click(function(){
    count += 5;
    $("#images-look .image-item").each(function(index, item) {
      if( index < count ){
        $(item).removeClass("hidden");
      }     
    }); 

    console.log(countImage);
    console.log("show-"+ count);
    if( count >= countImage ){
      console.log("end");
      $('#loading-img').removeClass("active");
      $('#loading-img').addClass("end");
      return false;
    }

  });
});

$(document).ready(function(){

  var windowWidth = $(window).width();
  if (windowWidth >= 1200) {
    var hoverTimeout;
    $('body').removeClass('mobile-only').addClass('desktop-only');
    $('.toggleMenu').removeClass('isMobile').addClass('isDesktop');
    $('.responsiveMenu').show().removeClass('isMobile').addClass('isDesktop');
    $('.responsiveMenu li').removeClass('hover isMobile').addClass('isDesktop');
    $('.responsiveMenu li a').unbind('click');
    $('.responsiveMenu li.parent').unbind('mouseenter').bind('mouseenter', function () {          
      clearTimeout(hoverTimeout);
      $('.responsiveMenu li.hover').removeClass('hover');
      $(this).addClass('hover');
    });
    $('.responsiveMenu li.parent').unbind('mouseleave').bind('mouseleave', function () {
      var $this=$(this);
      hoverTimeout = setTimeout(function() {
        $this.removeClass('hover');
      },250);
    });
  }else{
    $('body').removeClass('desktop-only').addClass('mobile-only');
    $('.toggleMenu').removeClass('isDesktop').addClass('isMobile');
    if (!$('.toggleMenu').hasClass('active')) {
      $('.responsiveMenu').hide().removeClass('isDesktop').addClass('isMobile');
    } else {
      $('.responsiveMenu').show().removeClass('isDesktop').addClass('isMobile');
    }
    $('.responsiveMenu .parent-level-ul').removeAttr('style');
    $('.responsiveMenu li').unbind('mouseenter mouseleave').removeClass('isDesktop').addClass('isMobile');    
    $('.responsiveMenu li.has-dropdown a.parent').unbind('click').bind('click', function(e) {
      e.preventDefault();
      $(this).parent('li').toggleClass('hover');
    });
    $('.responsiveMenu li a.parent span').click(function(){
      if((typeof $(this).parent().attr('href') != 'undefined') && $(this).parent().attr('href') != '#'){
        $(this).parent().unbind('click');
        myLink = $(this).parent().attr('href');
        window.location.href = myLink;
      }
    });
  }

});

$(window).resize(function() {
  var windowWidth = $(window).width();
  if (windowWidth >= 1200) {
    var hoverTimeout;
    $('body').removeClass('mobile-only').addClass('desktop-only');
    $('.toggleMenu').removeClass('isMobile').addClass('isDesktop');
    $('.responsiveMenu').show().removeClass('isMobile').addClass('isDesktop');
    $('.responsiveMenu li').removeClass('hover isMobile').addClass('isDesktop');
    $('.responsiveMenu li a').unbind('click');
    $('.responsiveMenu li.parent').unbind('mouseenter').bind('mouseenter', function () {          
      clearTimeout(hoverTimeout);
      $('.responsiveMenu li.hover').removeClass('hover');
      $(this).addClass('hover');
    });
    $('.responsiveMenu li.parent').unbind('mouseleave').bind('mouseleave', function () {
      var $this=$(this);
      hoverTimeout = setTimeout(function() {
        $this.removeClass('hover');
      },250);
    });
  }else{
    $('body').removeClass('desktop-only').addClass('mobile-only');
    $('.toggleMenu').removeClass('isDesktop').addClass('isMobile');
    if (!$('.toggleMenu').hasClass('active')) {
      $('.responsiveMenu').hide().removeClass('isDesktop').addClass('isMobile');
    } else {
      $('.responsiveMenu').show().removeClass('isDesktop').addClass('isMobile');
    }
    $('.responsiveMenu .parent-level-ul').removeAttr('style');
    $('.responsiveMenu li').unbind('mouseenter mouseleave').removeClass('isDesktop').addClass('isMobile');    
    $('.responsiveMenu li.has-dropdown a.parent').unbind('click').bind('click', function(e) {
      e.preventDefault();
      $(this).parent('li').toggleClass('hover');
    });
    $('.responsiveMenu li a.parent span').click(function(){
      if((typeof $(this).parent().attr('href') != 'undefined') && $(this).parent().attr('href') != '#'){
        $(this).parent().unbind('click');
        myLink = $(this).parent().attr('href');
        window.location.href = myLink;
      }
    });
  }
});

